export const googleMapOption = {
  enableHighAccuracy: true,
  maximumAge: 0,
  timeout: 6000,
}
